import { Component } from '@angular/core';
var A2tHeadlineComponent = (function () {
    function A2tHeadlineComponent() {
    }
    return A2tHeadlineComponent;
}());
export { A2tHeadlineComponent };
A2tHeadlineComponent.decorators = [
    { type: Component, args: [{
                selector: 'a2t-headline',
                template: '<p><ng-content></ng-content></p>',
                styles: ["\n        p {\n            text-align: center;\n            color: white;\n            font-size: 30px;\n        }\n    "]
            },] },
];
/** @nocollapse */
A2tHeadlineComponent.ctorParameters = function () { return []; };
//# sourceMappingURL=a2t-headline.component.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/lib/a2t-ui/a2t-shared/a2t-headline/a2t-headline.component.js
// module id = ../../../../angular2-token/lib/a2t-ui/a2t-shared/a2t-headline/a2t-headline.component.js
// module chunks = 3